<template>
	<div style="padding-top: 30px;">

		<el-table ref="multipleTable" :header-cell-style="{ background: '#e9e9e9' }" v-loading="loading" :border="true" :stripe="true" :data="list" highlight-current-row>

			<el-table-column label="留言标题" min-width="60%" align="left" header-align="center" prop="title" >
				<template slot-scope="scope">
				  <div @click="viewDetail(scope.row)" style="cursor: pointer;">
					{{scope.row.title}}
				  </div>
				</template>
			</el-table-column>
			<!-- <el-table-column label="姓名" min-width="20%" align="center" prop="name" /> -->
			<el-table-column label="留言时间" min-width="20%" align="center" prop="msgTime" />
		</el-table>
		<el-pagination :total="total" :pager-count="pagerCount" :current-page="pageNum" :page-size="pageSize"
			layout="total,prev,pager,next" background @current-change="currentChange"
			style="margin-top: 10px;">
		</el-pagination>


		<!-- 详情 -->
		<el-dialog class="tag-pop" title="留言结果" :visible.sync="tagopen" width="65%">
			<div style="color: #606266;text-align: center;font-size: 16px;">
				<div style="background-color: #62a0ff;color: #fff;line-height: 30px;">{{detail.title}}</div>
				<div style="background-color: #f6f6f6;margin-top: 2px;line-height: 30px;">留言内容</div>
				<div style="background-color: #fff;margin-top: 2px;line-height: 30px;text-indent: 2em;text-align: left;">{{detail.msgContent}}</div>
				<div style="background-color: #f6f6f6;margin-top: 10px;line-height: 30px;">回复内容</div>
				<div style="background-color: #fff;margin-top: 2px;line-height: 30px;text-align: left;text-indent: 2em;">{{detail.replyContent}}</div>
				
				<div style="background-color: #fff;margin-top: 20px;text-align: right;">回复部门：{{detail.replyDept}}</div>
				<div style="background-color: #fff;margin-top: 5px;text-align: right;">{{detail.replyTime}}</div>
			</div>
			<div slot="footer" class="dialog-footer" style="text-align: center;">
				<el-button type="primary" @click="guanbi">关闭</el-button>
			</div>
		</el-dialog>

	</div>

</template>

<script>
	export default {
		name: 'list',
		data() {


			return {
				loading: true,
				pageNum: 1,
				pageSize: 20,
				list: [],
				total: null,
				pagerCount:( document.body.clientWidth < 992 ? 5 : 7),
				tagopen: false,
				
				detail:{}

			}
		},
		methods: {
			currentChange(val) {
				this.pageNum = val
				this.handleQuery()

			},
			guanbi(){
				this.tagopen=false
			},
			handleQuery() {
				this.loading = true;
				let that = this;

				this.axios.get('//hrdz.ccxmttech.com/prod-api/api/hbwwjlyb/system/content/api/list?pageNum='+this.pageNum+'&pageSize='+this.pageSize).then(
					res => {
						console.log()
						if (res.data.code == 200) {
							that.list = res.data.rows
							that.total = res.data.total
							// that.pageCount = res.data.data.pagecount


						} else {
							that.$message({
								message: res.data.msg,
								type: 'error'
							});
							this.list = []
						}
						this.loading = false;
					})
			},
			viewDetail(row){
				// row.id
				this.detail = row
				this.tagopen=true
			}



		},
		mounted() {
			this.handleQuery()

		}
	}
</script>

<style>
	.login-code {
		width: 33%;
		height: 38px;
		float: right;

	}

	.login-code img {
		cursor: pointer;
		vertical-align: middle;
	}

	.login-code-img {
		height: 38px;
	}
</style>